import { render } from "./SortPopup.vue?vue&type=template&id=f9527a0a"
import script from "./SortPopup.vue?vue&type=script&lang=js"
export * from "./SortPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__